import {Component, Input} from "@angular/core";
import {ControlContainer, NgForm} from "@angular/forms";
import {RgpdParam} from "@domain/admin/entreprise/rgpd-param";

/**
 * Composant contenant le formulaire avec les différentes règles RGPD de l'entreprise
 */
@Component({
    host: {'data-test-id': 'rgpd'},
    selector: 'rgpd',
    templateUrl: './rgpd.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class RgpdComponent {
    /** Ensemble des paramètres RGPD de l'entreprise */
    @Input() rgpdParams: RgpdParam;

    /** Indique si l'utilisateur est admin ou sous-admin */
    @Input() isAdmin: boolean = false;
}